import script from "./login-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./login-page.vue?vue&type=script&setup=true&lang=ts"

import "./login-page.vue?vue&type=style&index=0&id=890f46c6&lang=less"

const __exports__ = script;

export default __exports__